import React from 'react';
import { PLACEHOLDER_ARTICULO } from '../utils/placeholders';

const FavoritesSection = ({ favoriteArticles, onViewAll, onSelectArticle }) => {

  const getSectionIcon = (sectionTitle) => {
    const icons = {
      'Evangelio': '📖',
      'Buenos días': '🌅',
      'Clave agustiniana': '🔑',
      'Santos Agustinos': '👼',
      'Vocaciones': '✨',
      'Vamos al cole': '🎒',
      'Te interesa': '🌍',
      'Está pasando': '📰',
      'Eventos': '🎪'
    };
    return icons[sectionTitle] || '📄';
  };

  const getIconGradient = (sectionTitle) => {
    const gradients = {
      'Evangelio': 'linear-gradient(135deg, #e62c19 0%, #a01916 100%)',
      'Buenos días': 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
      'En clave agustiniana': 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
      'Santos Agustinos': 'linear-gradient(135deg, #ffd700 0%, #ffb347 100%)',
      'Vocaciones': 'linear-gradient(135deg, #ff6b6b 0%, #feca57 100%)',
      'Vamos al cole': 'linear-gradient(135deg, #48cae4 0%, #023e8a 100%)',
      'Te interesa': 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      'Está pasando': 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
      'Eventos': 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)'
    };
    return gradients[sectionTitle] || 'linear-gradient(135deg, #e62c19 0%, #a01916 100%)';
  };

  const getImageUrl = (item) => {
    return item.imageUrl || item.image || item.thumbnail ||
      PLACEHOLDER_ARTICULO;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
    } catch {
      return '';
    }
  };

  if (!favoriteArticles || favoriteArticles.length === 0) {
    return null;
  }

  const lastFavorite = favoriteArticles[0];
  const sectionName = lastFavorite.section || '';

  return (
    <section className="mb-4 md:mb-6 lg:mb-8 px-1 md:px-6 lg:px-8 no-overflow">
      {/* Encabezado de sección */}
      <div className="flex justify-between items-center mb-4 px-4 md:px-0">
        <h2 className="responsive-title text-primary flex items-center gap-2">
          <span className="text-xl md:text-2xl lg:text-3xl">⭐️</span>
          Mis favoritos
        </h2>
        <button
          onClick={() => onViewAll && onViewAll()}
          className="text-sm font-semibold hover:underline transition-colors"
          style={{ color: 'var(--primary-red)' }}
        >
          Ver todos ({favoriteArticles.length})
        </button>
      </div>

      {/* Card del último favorito */}
      <div className="space-y-4">
        <div
          className="modern-card stagger-animation animate-slide-up cursor-pointer"
          onClick={() => onSelectArticle && onSelectArticle(lastFavorite, sectionName)}
        >
          <div className="flex items-start gap-5">
            {lastFavorite.imageUrl ? (
              <div className="w-20 h-20 rounded-xl overflow-hidden flex-shrink-0 bg-gray-100">
                <img
                  src={getImageUrl(lastFavorite)}
                  alt={lastFavorite.title}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.parentNode.innerHTML = `<div class="section-icon" style="background: ${getIconGradient(sectionName)}; width: 80px; height: 80px; border-radius: 12px;">${getSectionIcon(sectionName)}</div>`;
                  }}
                />
              </div>
            ) : (
              <div
                className="section-icon flex-shrink-0"
                style={{
                  background: getIconGradient(sectionName),
                  width: '80px',
                  height: '80px',
                  borderRadius: '12px'
                }}
              >
                {getSectionIcon(sectionName)}
              </div>
            )}

            <div className="flex-1 min-w-0">
              <h3 className="text-base font-semibold text-primary mb-2 line-clamp-2 leading-tight">
                {lastFavorite.title}
              </h3>

              {(lastFavorite.description || lastFavorite.subtitle) && (
                <p className="text-secondary text-sm line-clamp-2 leading-relaxed mb-2 whitespace-pre-wrap">
                  {lastFavorite.description || lastFavorite.subtitle}
                </p>
              )}

              <div className="flex items-center gap-3 text-xs text-secondary">
                {lastFavorite.date && (
                  <span className="flex items-center gap-1">
                    📅 {formatDate(lastFavorite.date)}
                  </span>
                )}
                {sectionName && (
                  <span className="flex items-center gap-1">
                    {getSectionIcon(sectionName)} {sectionName}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FavoritesSection;
